import React from "react";
import { connect } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

// react-router v7: route guards are element wrappers, not `<Route render>`.
// Used as `<Route path=... element={<PrivateRoute component={X} ... />} />`.
// v5 `<Redirect>` defaulted to REPLACE — `<Navigate replace />` matches.
const PrivateRoute = ({ component: Component, isAuthenticated, children }) => {
  const location = useLocation();
  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: "/login",
          search: location.search,
        }}
        replace
        state={{ from: location }}
      />
    );
  }
  return Component ? <Component /> : children;
};

const mapStateToProps = ({ authentication }) => ({
  isAuthenticated: authentication.isAuthenticated,
});
export default connect(mapStateToProps, null)(PrivateRoute);
